<template>
    <div class="my-3">
        <ul v-if="paymentMethods">
            <li v-for="(payment, index) in form.billing.payments" class="d-flex mb-3">
                
                <div class="d-flex">
                    <div class="flex-all mr-3">
                        <label>Payment Method</label>
                        <vSelect 
                            v-model="payment.type" 
                            :options="paymentMethods" 
                            :searchable="false"
                            placeholder="- Select type -" 
                            label="description">
                        </vSelect>
                    </div>

                    <div class="flex-all">
                        <label>Amount</label>
                        <input type="number" class="mb-0 text-right" v-model="payment.value" @keyup="validatePayments">
                    </div>

                    <div class="mt-4 ml-3 pt-1">
                        <div v-if="index > 0" @click="deleteRow(index)">
                            <i class="ico-delete color-1 larger pointer"></i>
                        </div>
                        <div v-else @click="addRow(payment.type)">
                            <i class="ico-add add-circle"></i>
                        </div>
                    </div>
                </div>

            </li>
        </ul>

        <ul v-if="!validTotal || !validDeposit">
            <li v-if="!validTotal" class="d-flex error align-items-center mb-4">
                <i class="ico-alert largest"></i>
                The payment amount exceeds the total price for this product.
            </li>
            <li v-if="!validDeposit" class="d-flex error align-items-center mb-4">
                <i class="ico-alert largest"></i>
                Deposit must be charged - minimum value {{ this.deposit.toFixed(2) }}&euro;.
            </li>
        </ul>
    </div>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex'
    import { reservationsMixin } from '@/mixins/reservations'
    import extendedVSelect from '@/extends/vue-select'

    export default {
        mixins: [reservationsMixin],
        props: {
            reservation: Object,
            product: Object,
        },
        data: function () {
            return {
                form: {},
            }
        },
        created: function() {
            if (this.reservation) {
                this.form = JSON.parse(JSON.stringify(this.reservation));
            }
        },
        asyncComputed: {
            async paymentMethods() {
                try {
                    let response = await axios.get('/api/settings/GetPaymentTypeList');

                    if (response && response.status === 200 && response.data) {
                        // Map FK information through selects

                        if (this.form.billing === undefined || !this.form.billing) {
                            this.$set(this.form, 'billing', []);
                        }

                        if (this.form.billing.payments === undefined || !this.form.billing.payments) {
                            this.$set(this.form.billing, 'payments', []);
                            this.addRow(response.data[0]);
                        }

                        return response.data;
                    }
                }
                catch (error) {
                    this.$toasted.error(error);
                }
            },
        },
        computed: {
            paymentsTotal: function() {
                let total = 0;
                
                if (this.form.billing.payments !== undefined && this.form.billing.payments) {
                    this.form.billing.payments.forEach(item => {
                        if (item.value === '') {
                            item.value = 0;
                        }
                        total += parseFloat(item.value);

                    });
                }

                return total;
            },
            validTotal: function() {
                return (this.paymentsTotal <= this.finalPrice);
            },
            validDeposit: function() {
                return (this.paymentsTotal >= this.deposit);
            },
        },
        methods: {
            addRow: function(defaultType) {
                this.form.billing.payments.push({
                    type: defaultType,
                    value: '0.00',
                    currency: '€'
                });

                console.log('Added row', this.form.billing.payments);
            },
            deleteRow: function(row) {
               this.form.billing.payments.splice(row, 1);
               this.validatePayments();
            },
            validatePayments: function() {
                const valid = (!this.validTotal || !this.validDeposit);

                this.$emit('validatePayments', valid);
                this.$emit('updatePayments', this.form.billing.payments);
            },
        },
        components: {
            vSelect: extendedVSelect,
        },
    }
</script>



// WEBPACK FOOTER //
// PaymentMethods.vue?f150f35c